const FacebookIcon = ({className} : {className?:string}) => {
  return (
<svg className={className} width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.40625 11.5H9.90625L10.9062 7.5H7.40625V5.5C7.40625 4.47 7.40625 3.5 9.40625 3.5H10.9062V0.14C10.5802 0.0970001 9.34925 0 8.04925 0C5.33425 0 3.40625 1.657 3.40625 4.7V7.5H0.40625V11.5H3.40625V20H7.40625V11.5Z" fill="currentColor"/>
</svg>
  )
}

export default FacebookIcon